import { render, staticRenderFns } from "./topCourts.vue?vue&type=template&id=172aaf79&scoped=true&"
import script from "./topCourts.vue?vue&type=script&lang=js&"
export * from "./topCourts.vue?vue&type=script&lang=js&"
import style0 from "./topCourts.vue?vue&type=style&index=0&id=172aaf79&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172aaf79",
  null
  
)

export default component.exports